module.exports = __webpack_public_path__ + "assets/22b2b542005de857a76c0a128feb37a8.mp3";